import p from "./ghl-ui.es1193.js";
var t = typeof exports == "object" && exports && !exports.nodeType && exports, e = t && typeof module == "object" && module && !module.nodeType && module, u = e && e.exports === t, r = u && p.process, d = function() {
  try {
    var o = e && e.require && e.require("util").types;
    return o || r && r.binding && r.binding("util");
  } catch {
  }
}();
const n = d;
export {
  n as default
};
